import React, { useRef } from "react";
import "../styles/ContactSection.css";
import { useSectionReveal } from '../hooks/useSectionReveal';

const ContactSection = () => {
  const sectionRef = useRef(null);
  useSectionReveal(sectionRef);

  return (
    <section className="contact-section" ref={sectionRef}>
      <div className="contact-background">
        <div className="contact-overlay">
          <h2>Get in Touch</h2>
          <p>I am here to help you elevate your tennis game. Reach out to me for any queries or to schedule a session.</p>
          
          {/* Contact Information */}
          <div className="contact-info">
            <p><strong>Email:</strong> kzubricky@gmail.com </p>
            <p><strong>Phone:</strong> 440-915-2518</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;

